import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../theme/colors';

export const useHubCardStyles = makeStyles<Theme, { removeToPadding?: boolean }>(() => ({
  card: {
    padding: '16px 0',
    borderRadius: '10px',
    marginBottom: '40px',
    position: 'relative',
    zIndex: 1
  },
  towerContainer: {
    zIndex: 100,
    overflowX: 'auto',
    padding: (options) => (options.removeToPadding ? '1px 24px 0 28px' : '24px 24px 0 28px'),
    // first child of all but the first children of the tower container
    // margin prevents a double border
    '& > *:not(:first-child) > *': {
      marginLeft: '1px'
    }
  },
  hubSideToggleTabs: {
    marginLeft: '27px'
  },
  hubSideToggleTabsIndicator: {
    backgroundColor: Colors.deliveredBlue,
    height: '3px'
  },
  hubSideToggleTab: {
    color: Colors.bookedScannedInProgressGray,
    '&:hover': {
      color: Colors.deliveredBlue
    }
  },
  hubSideToggleTabSelected: {
    color: Colors.deliveredBlue,
    fontWeight: 600
  },
  transactionTypesContainer: {
    display: 'flex',
    flexDirection: 'row' as const,
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    padding: '8px 28px 0 28px',
    width: '100%'
  },
  transactionTypesRightSlot: {
    display: 'flex',
    alignItems: 'center'
  },
  transactionTypeIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    backgroundColor: 'transparent',
    transition: 'background-color 0.2s ease-in-out',
    cursor: 'default',
    '&:hover': {
      backgroundColor: Colors.darkGray
    }
  },
  transactionTypeIconSvg: {
    width: '20px',
    height: '20px',
    color: '#6F6F6F',
    transition: 'color 0.2s ease-in-out',
    '$transactionTypeIcon:hover &': {
      color: Colors.white
    }
  }
}));
